(() => {
  // V6 — két külön kötelező doboz, adminból szerkeszthető szövegekkel
  if (window.__CONSENT_ANCHOR_V6__) return; window.__CONSENT_ANCHOR_V6__ = true;

  const selCheckoutBtns = [
    'button[name="checkout"]',
    '[type="submit"][name="checkout"]',
    'button#checkout',
    '.cart__checkout-button',
    '.cart__blocks button[type="submit"]'
  ];
  const dynSelectors = [
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.dynamic-checkout',
    '.shopify-cleanslate'
  ];

  const q  = (s, r=document) => r.querySelector(s);
  const qa = (s, r=document) => Array.from(r.querySelectorAll(s));
  const visible = el => !!(el && (el.offsetParent || el.getClientRects().length));

  const getCartForm = () => {
    const c = qa('form[action="/cart"]');
    return c.find(visible) || c[0] || null;
  };

  // Gyorsfizetés ELREJTÉSE pipa nélkül (összállapot alapján)
  function setDynamicHidden(hidden) {
    qa(dynSelectors.join(',')).forEach(el => { el.style.display = hidden ? 'none' : ''; });
  }

  // Fő checkout gomb vizuális tiltása/engedése (DE kattintható marad tiltva is, hogy kiírjuk a hibát)
  function setMainCheckoutDisabled(dis) {
    const btns = [
      ...document.querySelectorAll('button[name="checkout"]'),
      ...document.querySelectorAll('[type="submit"][name="checkout"]'),
      ...document.querySelectorAll('button#checkout'),
      ...document.querySelectorAll('.cart__checkout-button'),
      ...document.querySelectorAll('.cart__blocks button[type="submit"]')
    ];
    btns.forEach(btn => {
      if (!btn || !(btn.offsetParent || btn.getClientRects().length)) return;
      try {
        if (dis) {
          btn.disabled = false;
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-disabled','disabled');
        } else {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-disabled','disabled','button--disabled');
          btn.style.opacity = '';
          btn.style.filter = '';
          btn.style.pointerEvents = '';
          btn.style.cursor = '';
        }
      } catch {}
    });
  }

  // Order note attributes biztosítása adott "suffix"-szel: "", "2", "3", ...
  function ensureHiddenFields(form, suffix, finalText) {
    const key = (k) => suffix ? `attributes[consent${suffix}_${k}]` : `attributes[consent_${k}]`;
    const defs = [
      [key('checked'), 'false'],
      [key('text_v1'), finalText || ''],
      [key('at'),     '']
    ];
    defs.forEach(([name, val]) => {
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = val;
        form.appendChild(input);
      }
    });
  }

  const esc = s => String(s ?? '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));

  // Egy doboz felépítése egy adott anchor-ba
  function mountInto(anchor) {
    // suffix: az anchor id végén lévő szám (pl. consent-anchor-2 -> "2"), különben ""
    const m = (anchor.id || '').match(/(\d+)$/);
    const suffix = m ? m[1] : '';

    // Szövegek az anchor data attribútumaiból
    const title   = anchor.dataset.title    || 'Kötelező elfogadás';
    const text    = anchor.dataset.text     || 'A vásárló kijelenti, hogy elfogadja a rendeléshez kapcsolódó tájékoztatást és feltételeket.';
    const linkUrl = anchor.dataset.linkUrl  || '';
    const linkTxt = anchor.dataset.linkText || '';
    const errText = anchor.dataset.error    || 'A rendelés folytatásához jelöld be a jelölőnégyzetet.';
    const textHtml = esc(text) + (linkUrl && linkTxt
      ? ' <a href="' + esc(linkUrl) + '" target="_blank" rel="noopener">' + esc(linkTxt) + '</a>'
      : '');

    // Orderbe menő plain log szöveg
    const plainForLog = text + (linkUrl && linkTxt ? ` [${linkTxt}: ${linkUrl}]` : '');

    anchor.innerHTML = `
      <div id="consent-wrapper${suffix}"
           style="color:#111827;background:#fffdf0;border:1px solid #e5e7eb;border-radius:12px;
                  padding:14px 16px;font:14px/1.5 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif; margin-bottom:12px;">
        <label style="display:flex;gap:.6rem;align-items:flex-start;cursor:pointer;margin:0;">
          <input id="consent-checkbox${suffix}" type="checkbox" style="margin-top:3px;flex:0 0 auto;">
          <span style="display:block">
            <div style="font-weight:600;margin-bottom:4px;">${esc(title)}</div>
            <div id="consent-text${suffix}">${textHtml}</div>
            <div id="consent-error${suffix}" style="display:none;color:#b91c1c;margin-top:.5rem;">
              ${esc(errText)}
            </div>
          </span>
        </label>
      </div>
    `;

    const form = getCartForm();
    if (form) ensureHiddenFields(form, suffix, plainForLog);

    const cb       = q(`#consent-checkbox${suffix}`, anchor);
    const err      = q(`#consent-error${suffix}`, anchor);
    const wrap     = q(`#consent-wrapper${suffix}`, anchor);
    const key = (k) => suffix ? `attributes[consent${suffix}_${k}]` : `attributes[consent_${k}]`;
    const hChecked = form?.querySelector(`input[name="${key('checked')}"]`);
    const hAt      = form?.querySelector(`input[name="${key('at')}"]`);

    function setErrorVisible(v) { if (err) err.style.display = v ? 'block' : 'none'; }

    function apply() {
      const ok = !!cb?.checked;
      if (hChecked) hChecked.value = ok ? 'true' : 'false';
      if (hAt)      hAt.value      = ok ? new Date().toISOString() : '';
      setErrorVisible(!ok);
      return ok;
    }

    // kezdeti állapot (mutassuk a hibát, hogy egyből látszódjon mit kell tenni)
    setErrorVisible(true);

    return { suffix, cb, err, wrap, apply, isOk: () => !!cb?.checked };
  }

  // Össz-állapot alkalmazása (ha bármelyik doboz nincs bepipálva -> tiltjuk/eltüntetjük)
  function updateOverall(state) {
    const allOk = state.every(s => s.isOk());
    setMainCheckoutDisabled(!allOk);
    setDynamicHidden(!allOk);
  }

  function init() {
    // Támogatjuk: #consent-anchor és #consent-anchor-2 (illetve bármennyi .consent-anchor)
    const anchors = [
      ...qa('#consent-anchor, #consent-anchor-2, .consent-anchor')
    ];
    if (!anchors.length) { setTimeout(init, 200); return; }

    const state = anchors.map(mountInto);

    // Változáskezelők
    state.forEach(s => s.cb?.addEventListener('change', () => updateOverall(state)));

    // Kattintás blokkolása: ha bármelyik nincs bepipálva, akkor az első hibásra görgetünk
    document.addEventListener('click', (e) => {
      const t = e.target;
      let hit = false;
      for (const sel of selCheckoutBtns) { if (t.closest?.(sel)) { hit = true; break; } }
      if (!hit) return;

      const firstBad = state.find(s => !s.isOk());
      if (firstBad) {
        e.preventDefault(); e.stopPropagation();
        firstBad.err && (firstBad.err.style.display = 'block');
        firstBad.cb?.focus();
        firstBad.wrap?.scrollIntoView({ behavior:'smooth', block:'center' });
      }
    }, { capture: true });

    // Submit blokkolása is
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!f || !f.matches('form[action="/cart"]')) return;
      const firstBad = state.find(s => !s.isOk());
      if (firstBad) {
        e.preventDefault(); e.stopPropagation();
        firstBad.err && (firstBad.err.style.display = 'block');
        firstBad.cb?.focus();
        firstBad.wrap?.scrollIntoView({ behavior:'smooth', block:'center' });
      }
    }, { capture: true });

    // Kezdeti összállapot
    updateOverall(state);

    // DOM változáskor tartsuk karban az összállapotot (ha a téma újrarajzolja a footer-t)
    const mo = new MutationObserver(() => updateOverall(state));
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();